export default class ViewModeToggleCtrl {
  $onChanges() {
    this.displayMode = this.selectedMode;
  }
}
